import apiClient from '../api/client';
import {ENDPOINTS} from '../api/endpoints';

export const purchaseOrdersService = {

    removeEmptyValue(body) {
        return Object.fromEntries(
            Object.entries(body).filter(([key, value]) => {
                if (Array.isArray(value)) {
                    return value?.length;
                } else {
                    return value !== '';
                }
            })
        );
    },

    searchPurchaseOrders: async (criteria) => {
        const response = await apiClient.post(
            `${ENDPOINTS.PURCHASE_ORDERS}/search`,
            criteria
        );
        return response.data;
    },

    findPurchaseOrderById: async (id) => {
        const response = await apiClient.get(
            `${ENDPOINTS.PURCHASE_ORDERS}/${id}`
        );
        return response.data;
    },

    updatePurchaseOrdersById: async (id, data) => {
        const response = await apiClient.put(
            `${ENDPOINTS.PURCHASE_ORDERS}/${id}`,
            data
        );
        return response.data;
    },

    updatePurchaseOrdersDiagnosticById: async (id, data) => {
        const response = await apiClient.put(
            `${ENDPOINTS.PURCHASE_ORDERS}/diagnostics/${id}`,
            data
        );
        return response.data;
    },

    cancelPurchaseOrder: async (id) => {
        const response = await apiClient.get(
            `${ENDPOINTS.PURCHASE_ORDERS}/cancel/${id}`
        );
        return response.data;
    },

    getDiagnosticTypes: async () => {
        const response = await apiClient.get(
            `${ENDPOINTS.PURCHASE_ORDERS}/diagnostics/types`
        );
        return response.data;
    },

    findAutocompleteDiagnosticians: async (value) => {
        const response = await apiClient.post(
            `${ENDPOINTS.PURCHASE_ORDERS}/diagnosticians/autocomplete`,
            value,
            {
                headers: {
                    'Content-Type': 'text/plain'
                }
            }
        );
        return response.data;
    },

    findAutocompleteContact: async (value) => {
        const response = await apiClient.post(
            `${ENDPOINTS.PURCHASE_ORDERS}/contacts/autocomplete`,
            value,
            {
                headers: {
                    'Content-Type': 'text/plain'
                }
            }
        );
        return response.data;
    }

};